import { render } from "./zhenggaoyaoxue-news.vue?vue&type=template&id=84418b4e&scoped=true"
import script from "./zhenggaoyaoxue-news.vue?vue&type=script&lang=js"
export * from "./zhenggaoyaoxue-news.vue?vue&type=script&lang=js"

import "./zhenggaoyaoxue-news.vue?vue&type=style&index=0&id=84418b4e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84418b4e"]])

export default __exports__